<template>
  <TextReading
    @originalClick="updateCity"
    ref="textReading"
    :article-detail="detailData"
    :collect-handler="collect"
    :collect-status="detailData.follow_state === '1'"
    :chapter-change-handler="chapter"
    :limit-id="limitId"
    :has-print="true"
    :has-original="baseData.epubfilepath == '1'"
  >
    <div class="nav-wrap">
      <el-popover placement="top-start" trigger="hover" :offset="0" popper-class="qrcode-popover">
        <div class="common-qrcode-content">
          <div ref="qrcode" />
        </div>
        <img
          slot="reference"
          class="common-qrcode-popover"
          src="@/assets/img/qrcode.png"
        />
      </el-popover>
      <div class="subscribe-card-wrap">
        <div class="subscribe-card">
          <div class="cover hb-resource-cover">
            <img v-if="baseData" :src="baseData.poster" />
          </div>
          <div class="infos">
            <h4 class="text1line">
              {{ langTransfer(baseData.name) }}
            </h4>
            <p v-if="baseData.year && baseData.issue" class="text1line">
              {{
                langTransfer(
                  `${baseData.year}年${('0' + baseData.issue).substr(-2)}期`,
                )
              }}
            </p>
            <div
              v-show="webInfo.isAllowLogin == '1' && baseData.name"
              class="subscribe-btn-wrap lr-img-scale"
              @click="addFocus"
            >
              <LottieAddBtn :is-collection="baseData.isShowAuthor === '1'" />
            </div>
          </div>
        </div>
      </div>
      <div class="catelog-mask">
        <h5>{{ langTransfer('目录') }}</h5>
        <bscroll-view hide-scroll-bar>
          <div class="catelog-list">
            <div
              v-for="(item, index) in menuList"
              :key="index"
              class="cate-item"
            >
              <p class="cate-item-name text1line">
                {{ langTransfer(item.columns) }}
              </p>
              <div class="sub-list">
                <div
                  v-for="sub in item.list"
                  :key="sub.id"
                  class="sub-item"
                  @click="subCateClick(sub.id)"
                >
                  <p
                    class="sub-item-name text1line"
                    :style="{
                      'font-weight': $route.params.id === sub.id ? '' : '',
                      color: $route.params.id === sub.id ? '#303133' : '',
                    }"
                  >
                    {{ langTransfer(sub.title) }}
                  </p>
                  <p
                    class="sub-item-summary text2line"
                    :style="{
                      color: $route.params.id === sub.id ? '#606266' : '',
                    }"
                  >
                    {{ langTransfer(sub.describes) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </bscroll-view>
      </div>
    </div>
    <div
      slot="content-related"
      class="recommend-article-wrap"
      v-if="artList != ''"
    >
      <div class="header-wrap">
        <h5>
          {{ langTransfer('相关推荐') }}
        </h5>
      </div>
      <div class="list-wrap">
        <div
          v-for="(item, index) in artList"
          :key="index"
          class="item"
          @click="detailDispatcher('magazineArticle', item)"
        >
          <div class="infos">
            <h6 class="text1line">
              <!-- {{ langTransfer(item.title) }} -->
              {{ langTransfer(item.Title) }}
            </h6>
            <p class="text2line" v-html="langTransfer(item.Summary)">
              <!-- {{ langTransfer(item.describes) }} -->
              <!-- {{langTransfer(item.Summary)}} -->
            </p>
            <div class="other-info">
              {{ langTransfer('栏目名称：') }}
              {{ langTransfer(item.Columns || item.columns) }}
            </div>
          </div>
          <!-- <div v-show="!item.poster" class="hb-resource-cover">
            <img
              v-lazy="
                'https://images.pexels.com/photos/1458736/pexels-photo-1458736.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500' ||
                item.poster
              "
            />
          </div> -->
        </div>
      </div>
    </div>
  </TextReading>
</template>
<script>
import TextReading from '@/components/textReading';
import LottieAddBtn from '@/components/lottieActions/add';
import BscrollView from '@/components/bscrollView';
import { resourceArticleDetail } from '@/api/lxc';
import { searchJournalArticle } from '@/api/hb';
import QRCode from 'qrcodejs2';

import {
  detail,
  journalCatalogList,
  collectCollect,
  qrCode,
} from '../../api/lyl';

export default {
  name: 'LevelFourCatalog',
  components: {
    TextReading,
    LottieAddBtn,
    BscrollView,
  },
  data() {
    return {
      artList: [],
      baseData: {},
      detailData: {},
      menuList: [],
      limitId: {
        start: '',
        end: '',
      },
      currentId: '',
    };
  },
  computed: {
    pageSetup() {
      return this.$store.state.pageSetup;
    },
    user_unique_code() {
      return this.$store.state.user_unique_code;
    },
    webInfo() {
      return this.$store.state.webInfo;
    },
  },
  watch: {
    webInfo(newVal) {
      if (newVal.service_code) {
        this.getMagazineDetail();
        this.getCatalog();
        const { id } = this.$route.params;
        if (id) {
          this.getArticle(id);
        }
      }
    },
  },
  methods: {
    initQrCode(text) {
      console.log(text);
      const ele = this.$refs.qrcode;
      ele.innerHTML = '';
      this.qrcodeObj = new QRCode(ele, {
        width: 110,
        height: 110,
        text,
      });
    },
    async getQrcode() {
      try {
        const data = await qrCode({
          type: 1,
          service_code: this.webInfo.service_code,
          id: this.$route.params.resId,
          user_unique_code: this.user_unique_code,
          year: this.detailData.year,
          issue: this.detailData.issue,
        });
        console.log(data);
        this.initQrCode(data);
      } catch (err) {
        console.log(err);
      }
    },
    async getMagazineSearch(item) {
      try {
        const data = await searchJournalArticle({
          service_code: this.webInfo.service_code,
          key: item,
          page: 1,
          pageSize: 10,
          type: 1,
        });
        this.artList = data.records;
      } catch (err) {
        this.articleList = [];
      }
    },
    updateCity(e) {
      this.detailDispatcher('magazineOriginal', this.baseData);
      this.buriedPoint();
    },
    async buriedPoint() {
      try {
        const { id, sourceType: authority } = this.$route.params;
        const data = await collectCollect({
          type: 21,
          resource_name: this.baseData.name,
          service_code: this.webInfo.service_code,
          resource_id: id,
          year: this.baseData.year,
          issue: this.baseData.issue,
        });
      } catch (err) {
        console.log(err);
      }
    },
    addFocus() {
      const formData = {
        type: 7,
        res_code: this.$route.params.resId,
        year: this.baseData.year,
        issue: this.baseData.issue,
      };
      const callback = (bool) => {
        if (bool) {
          this.baseData.isShowAuthor = '2';
        } else {
          this.baseData.isShowAuthor = '1';
        }
      };
      this.$utils.userCollect(formData, callback);
    },
    chapter(isPrev) {
      const { menuList } = this;
      const { id } = this.$route.params;
      const formatMenu = [];
      menuList.forEach((e) => {
        e.list.forEach((sub) => {
          formatMenu.push(sub);
        });
      });
      let newItem;
      const currentIndex = formatMenu.findIndex((e) => {
        return e.id === id;
      });
      if (isPrev) {
        newItem = formatMenu[currentIndex - 1];
      } else {
        newItem = formatMenu[currentIndex + 1];
      }
      if (!newItem) {
        return;
      }
      this.subCateClick(newItem.id);
    },
    subCateClick(id) {
      this.$router.push({
        params: {
          id,
        },
      });
      console.log(id);
    },
    async getMagazineDetail() {
      try {
        const { resId: id, year, issue } = this.$route.params;
        const data = await detail({
          service_code: this.webInfo.service_code,
          type: '1',
          year,
          issue,
          id,
          user_unique_code: this.user_unique_code,
        });
        this.baseData = data;
      } catch (err) {
        console.log(err);
      }
    },
    // 期刊目录
    async getCatalog() {
      try {
        const { resId: id, year, issue } = this.$route.params;
        const data = await journalCatalogList({
          service_code: this.webInfo.service_code,
          year: year || 2020,
          issue: issue || 12,
          id,
        });
        const { readStatus } = this.webInfo;
        if (Number(readStatus) !== 2) {
          this.menuList = data.slice(0, 3);
          return;
        }
        console.log(data);
        this.menuList = data;
        this.setLimitId();
        if (!this.$route.params.id && !this.detailData.content) {
          this.subCateClick(this.menuList[0].list[0].id);
        }
      } catch (err) {
        console.log(err);
      }
    },
    setLimitId() {
      const { menuList } = this;
      const endList = menuList[menuList.length - 1].list;
      this.limitId = {
        start: menuList[0].list[0].id,
        end: endList[endList.length - 1].id,
      };
    },
    async getArticle(newId) {
      try {
        const { id } = this.$route.params;
        const data = await resourceArticleDetail({
          service_code: this.webInfo.service_code,
          type: 1,
          id: newId || id,
          user_unique_code: this.user_unique_code,
        });
        console.log(data);
        this.detailData = data;
        this.getMagazineSearch(data.keywords);
        setTimeout(() => {
          this.getQrcode();
        }, 500);
      } catch (err) {
        console.log(err);
      }
    },
    collect() {
      const { id: res_code } = this.$route.params;
      const formData = {
        type: 6,
        res_code,
      };
      const callback = (bool) => {
        if (bool) {
          this.detailData.follow_state = '2';
        } else {
          this.detailData.follow_state = '1';
        }
      };
      this.$utils.userCollect(formData, callback);
    },
  },
  beforeRouteUpdate(to, from, next) {
    const { id } = to.params;
    this.getArticle(id);
    const { contentBScrollObj } = this.$refs.textReading;
    if (contentBScrollObj) {
      contentBScrollObj.finishPullUp();
      contentBScrollObj.scrollTo(0, 0);
    }
    next();
  },
  beforeRouteEnter: (to, from, next) => {
    next((vm) => {
      const { service_code } = vm.webInfo;
      if (service_code) {
        vm.getMagazineDetail();
        vm.getCatalog();
        const { id } = to.params;
        if (id) {
          vm.getArticle(id);
        }
      }
    });
  },
};
</script>

<style scoped lang="less">
.nav-wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.subscribe-card-wrap {
  width: 300px;
  height: 160px;
  box-sizing: border-box;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 8px 8px 0px 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.subscribe-card {
  width: 100%;
  height: 100%;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .cover {
    width: 90px;
    height: 120px;
    box-sizing: border-box;
    border-radius: 4px;
    cursor: auto;
    margin-right: 10px;
  }

  .infos {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    h4 {
      // height: 48px;
      font-size: 18px;
      font-family: AlibabaPuHuiTiM;
      color: #303133;
      line-height: 48px;
      user-select: none;
    }

    p {
      font-size: 13px;
      font-family: AlibabaPuHuiTiM;
      color: #909399;
      line-height: 20px;
      user-select: none;
      margin: 4px 0 12px;
    }
  }
}

.subscribe-btn-wrap {
  width: 80px;
  height: 36px;
  overflow: hidden;
  background: #303133;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.catelog-mask {
  width: 100%;
  flex: 1;
  overflow: hidden;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  h5 {
    padding: 10px 20px;
    margin-bottom: 15px;
    font-size: 16px;
    font-family: AlibabaPuHuiTiB;
    color: #303133;
    line-height: 16px;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    position: relative;

    &::before {
      content: '';
      display: block;
      width: 94px;
      height: 4px;
      background: #f0f2f5;
      position: absolute;
      top: 50%;
      left: -94px;
      margin-top: -2px;
    }

    &::after {
      content: '';
      display: block;
      width: 94px;
      height: 4px;
      background: #f0f2f5;
      position: absolute;
      top: 50%;
      right: -94px;
      margin-top: -2px;
    }
  }
}

.catelog-list {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 30px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .cate-item {
    width: 100%;
    padding: 20px 0 10px;
    font-size: 14px;
    font-family: AlibabaPuHuiTiR;
    color: #606266;
    line-height: 20px;
    border-bottom: 1px solid #f1f1f1;
    cursor: pointer;
    user-select: none;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .cate-item-name {
    width: 100%;
    font-size: 13px;
    font-family: AlibabaPuHuiTiM;
    color: #909399;
    line-height: 20px;
  }

  .sub-list {
    width: 100%;
    margin-top: 10px;
  }

  .sub-item {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      .sub-item-name {
        color: #303133;
      }

      .sub-item-summary {
        color: #606266;
      }
    }
  }

  .sub-item-name {
    width: 100%;
    font-size: 15px;
    font-family: AlibabaPuHuiTiM;
    color: #606266;
    line-height: 24px;
  }

  .sub-item-summary {
    width: 100%;
    font-size: 13px;
    font-family: AlibabaPuHuiTiR;
    color: #909399;
    line-height: 20px;
    max-height: 40px;
  }
}

.recommend-article-wrap {
  width: 740px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .header-wrap {
    width: 100%;
    height: 36px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    user-select: none;
    position: relative;
    z-index: 2;
    background: #fff;

    h5 {
      width: fit-content;
      height: 36px;
      box-sizing: border-box;
      padding: 10px 20px;
      font-size: 16px;
      font-family: AlibabaPuHuiTiB;
      color: #303133;
      line-height: 16px;
      background: #ffffff;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    }

    &::after {
      content: '';
      display: block;
      flex: 1;
      height: 4px;
      background: #f0f2f5;
    }
  }

  .list-wrap {
    width: 100%;
    margin: 20px 0 30px;

    .item {
      width: 100%;
      margin-bottom: 22px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      cursor: pointer;

      &:nth-child(2n) {
        margin-right: 0;
      }

      &:hover {
        h6,
        .other-info {
          color: #303133;
        }

        p {
          color: #606266;
        }
      }
    }

    .infos {
      flex: 1;

      h6 {
        font-size: 18px;
        font-family: AlibabaPuHuiTiM;
        color: #606266;
        line-height: 24px;
      }

      p {
        max-height: 40px;
        font-size: 13px;
        font-family: AlibabaPuHuiTiR;
        color: #909399;
        line-height: 20px;
        margin: 6px 0 12px;
      }

      .other-info {
        font-size: 13px;
        font-family: AlibabaPuHuiTiM;
        color: #606266;
        line-height: 20px;
      }
    }

    .hb-resource-cover {
      width: 104px;
      height: 104px;
      border-radius: 8px;
      margin-left: 20px;
    }
  }
}
</style>
